<template>
    <div class="page-wrapper">
        <header-bar></header-bar>
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
  import auth from '@/auth'
  import HeaderBar from './HeaderBar'

  export default {
    name: 'Container',
    components: {
      HeaderBar
    },
    data () {
      return {
        currentFlashMessages: null
      }
    },
    methods: {
      logout () {
        auth.logout()
        this.$router.push('/login')
      }
    }
  }
</script>

<style lang="scss">
    @import '../../../assets/sass/style';
</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/Container.vue